import dayjs from 'dayjs';
import { FC } from 'react';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';

import usePickupDetailsForm from './hooks/usePickupDetailsForm';

type PickupDetailsFormProps = {
  pickupDetailsFormState: ReturnType<typeof usePickupDetailsForm>;
};

const PickupDetailsForm: FC<PickupDetailsFormProps> = ({
  pickupDetailsFormState,
}) => {
  const { pickupDetailsForm, setPickupDetailsForm } = pickupDetailsFormState;

  return (
    <WaveUIForm_V2
      fields={[
        {
          field_type: FieldType.Switch,
          field_props: {
            name: 'pre_scheduled_pickup',
            label: 'Prescheduled Pickup',
            checked: pickupDetailsForm.pre_scheduled_pickup,
          },
        },
        {
          isVisible: !pickupDetailsForm.pre_scheduled_pickup,
          field_type: FieldType.DateTime,
          columns: 6,
          field_props: {
            name: 'ts_ready_at',
            label: 'Ready after',
            value: dayjs(pickupDetailsForm.ts_ready_at),
            withTime: true,
          },
        },
        {
          isVisible: !pickupDetailsForm.pre_scheduled_pickup,
          field_type: FieldType.DateTime,
          columns: 6,
          field_props: {
            name: 'ts_ready_until',
            label: 'Ready until',
            value: dayjs(pickupDetailsForm.ts_ready_until),
            withTime: true,
          },
        },
        {
          isVisible: !pickupDetailsForm.pre_scheduled_pickup,
          field_type: FieldType.Text,
          field_props: {
            name: 'pickup_location',
            label: 'Pickup Location',
            value: pickupDetailsForm.pickup_location,
            placeholder: 'Pickup Location ...',
          },
        },
        {
          isVisible: !pickupDetailsForm.pre_scheduled_pickup,
          field_type: FieldType.Text,
          field_props: {
            name: 'contact_name',
            label: 'Contact Name',
            value: pickupDetailsForm.contact_name,
            placeholder: 'Contact Name ...',
          },
        },
        {
          isVisible: !pickupDetailsForm.pre_scheduled_pickup,
          field_type: FieldType.Text,
          columns: 6,
          field_props: {
            name: 'contact_phone_number:number',
            label: 'Phone Number',
            value: pickupDetailsForm.contact_phone_number.number,
            placeholder: 'Phone Number ...',
          },
        },
        {
          isVisible: !pickupDetailsForm.pre_scheduled_pickup,
          field_type: FieldType.Text,
          columns: 6,
          field_props: {
            name: 'contact_phone_number:extension',
            label: 'Extension',
            value: pickupDetailsForm.contact_phone_number.extension,
            placeholder: 'Extension ...',
          },
        },
      ]}
      getFieldsValues={(val) => {
        const [key, value] = Object.entries(val)[0];

        setPickupDetailsForm((prev) => {
          const keyFractions = key.split(':');

          if (keyFractions.length > 1) {
            const fieldKey = keyFractions[0] as keyof typeof prev;
            const subFieldKey =
              keyFractions[1] as keyof (typeof prev)[typeof fieldKey];

            if (typeof prev[fieldKey] === 'object' && prev[fieldKey] !== null) {
              return {
                ...prev,
                [fieldKey]: {
                  ...(prev[fieldKey] as object),
                  [subFieldKey]: value,
                },
              };
            }
          }
          return { ...prev, ...val };
        });
      }}
    />
  );
};

export default PickupDetailsForm;
